import { CENTER_ORDER, MAX_WAIT_MINUTES, OPERATING_HOURS, WAIT_STEP_MINUTES } from './consts'
import type { HourPriority } from './types'

export const dateKey = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`

/** 운영일 D는 D-1일 23시부터 D일 22시까지다. */
export const operatingDate = (now: Date): Date => {
  const date = new Date(now)
  if (date.getHours() === 23) date.setDate(date.getDate() + 1)
  date.setHours(0, 0, 0, 0)
  return date
}
const operatingDateKey = (now: Date): string => dateKey(operatingDate(now))

export const validateDate = (value: string): void => {
  const date = new Date(`${value}T00:00:00`)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || Number.isNaN(date.getTime()) || dateKey(date) !== value) {
    throw new Error('유효한 날짜가 필요합니다.')
  }
}
export const validateHour = (hour: number): void => {
  if (!Number.isInteger(hour) || !OPERATING_HOURS.includes(hour)) throw new Error('시간대를 선택하세요.')
}
/** 범위 저장 대상: 비어 있거나 중복이면 시간 미선택과 같은 오류. */
export const validateHours = (hours: number[]): void => {
  if (hours.length === 0 || new Set(hours).size !== hours.length) throw new Error('시간대를 선택하세요.')
  hours.forEach(validateHour)
}
export const validatePriority = (value: HourPriority): void => {
  if (
    !Array.isArray(value.order) ||
    value.order.length !== CENTER_ORDER.length ||
    new Set(value.order).size !== CENTER_ORDER.length ||
    Array.from(value.order).some((id) => !CENTER_ORDER.includes(id))
  ) {
    throw new Error('센터 13곳의 전체 순위가 필요합니다. 매장 포함 순위는 저장할 수 없습니다.')
  }
  if (!Number.isInteger(value.wait) || value.wait < 0 || value.wait > MAX_WAIT_MINUTES || value.wait % WAIT_STEP_MINUTES !== 0) {
    throw new Error(`대기시간은 0~${MAX_WAIT_MINUTES}분, ${WAIT_STEP_MINUTES}분 단위로 입력하세요.`)
  }
}
export const isHourLocked = (date: string, hour: number, now: Date): boolean =>
  date !== operatingDateKey(now) || OPERATING_HOURS.indexOf(hour) < OPERATING_HOURS.indexOf(now.getHours())
